import Loading from "../../assets/icons/loading.lottie";
import { DotLottiePlayer } from "@dotlottie/react-player";

function ThemedSuspense() {
  return (
    <div className="w-full gap-y-4 flex text-brand flex-col items-center justify-center col-span-6 h-[80vh] p-6 text-lg font-medium">
      <DotLottiePlayer src={Loading} autoplay loop speed={1} className="w-32" />
      لطفا صبر کنید
    </div>
  );
}

export default ThemedSuspense;
